import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';
import { NotificationsService } from 'src/app/services/infra/notifications/notifications.service';

export interface IWarningDialogInput {
  elementsIds: string[];
  elementsNames: string[];
  title: string;
  body?: string;
  notificationMsgLabelPath: string;
  actionCallback?: (elementsIds: string[]) => Observable<unknown>;
  warningBanner?: string;
}

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss'],
})
export class WarningDialogComponent implements OnInit {
  public waitingForResponse = false;
  public stringToPresent = '';
  private _notificationMessage = 'was deleted successfully';

  constructor(
    public dialogRef: MatDialogRef<WarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public details: IWarningDialogInput,
    private readonly _httpErrorHandlerService: HttpErrorHandlerService,
    private readonly _notificationService: NotificationsService,
    private readonly _labelProvider: LabelsProviderPipe
  ) {}

  ngOnInit(): void {
    this.details.elementsNames.forEach((name) => {
      this.stringToPresent += name + ',\n';
    });
    this.stringToPresent = this.stringToPresent.slice(0, -2);

    if (this.details.notificationMsgLabelPath) {
      this._notificationMessage = this._labelProvider.transform(this.details.notificationMsgLabelPath);
    }
  }

  public confirmAction() {
    if (!this.details.actionCallback) {
      this.dialogRef.close(true);
    } else if (!this.waitingForResponse) {
      this.waitingForResponse = true;
      this.details.actionCallback(this.details.elementsIds).subscribe({
        next: (result) => {
          this._notificationService.success(this.stringToPresent + ' ' + this._notificationMessage);
          this.dialogRef.close(result ? result : true);
        },
        error: (httpError: HttpErrorResponse) => {
          if (this._httpErrorHandlerService.isUnhandledExceptionError(httpError.status)) {
            this._httpErrorHandlerService.handle(httpError);
          } else {
            this._notificationService.error(httpError.error.detail);
          }
          this.waitingForResponse = false;
        },
      });
    }
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
